import React, { useEffect, useState } from "react";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import TableCustom from "../../../components/table/tableCustom";
import CardSummaryGpa from "./components/cardGpa/CardSummaryGpa";
import StudentInfo from "./components/text/StudentInfo";
import { StudentApi } from "../../../api/student/student.api";
import { dateToView } from "../../../utils/date.utils";
import { ButtonBack } from "../../../components/button/ButtonCustoms";

const EducationInfoPage = () => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id_student = queryParams.get("id_student");
  const id_student_register_payment = queryParams.get("id_student");
  const id_student_term_payment = queryParams.get("id_student_term_payment");
  const fullname = queryParams.get("fullname");
  const middle_name = queryParams.get("middle_name");
  const course = queryParams.get("course");

  const [data, setData] = useState<any>([]);
  const [dataInfo, setDataInfo] = useState<any>({});

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>();
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const headCells = [
    {
      id: "#",
      width: 2,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "course_code",
      width: 15,
      disablePadding: false,
      align: "start",
      label: t("STUDENT_MANAGEMENT.EDUCATION_INFO.TABLE.COURSE_CODE_COLUMN"),
    },
    {
      id: "course_name",
      width: 15,
      disablePadding: false,
      align: "start",
      label: t("STUDENT_MANAGEMENT.EDUCATION_INFO.TABLE.COURSE_NAME_COLUMN"),
    },
    {
      id: "course_credit_unit",
      disablePadding: false,
      width: 15,
      align: "center",
      label: t(
        "STUDENT_MANAGEMENT.EDUCATION_INFO.TABLE.COURSE_CREDIT_UNIT_COLUMN"
      ),
    },
    {
      id: "grade",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("STUDENT_MANAGEMENT.EDUCATION_INFO.TABLE.GRADE_COLUMN"),
    },
    {
      id: "created_by",
      disablePadding: false,
      align: "center",
      width: 10,
      label: t("STUDENT_MANAGEMENT.EDUCATION_INFO.TABLE.CREATED_BY_COLUMN"),
    },
    {
      id: "created_at",
      disablePadding: false,
      align: "center",
      width: 35,
      label: t("STUDENT_MANAGEMENT.EDUCATION_INFO.TABLE.CREATED_AT_COLUMN"),
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const { id, courses, grade_courses, modified_id, modified_date } = objData;

    const objRenderData = {
      key: id,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${no}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: `${courses.courses_no}` || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: courses.courses_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: courses.credits || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: grade_courses || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: modified_id || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: modified_date ? dateToView(modified_date, false) : "-",
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const getEducationHistoryDetail = async (
    id_student: number,
    id_student_education: number
  ) => {
    const res = await StudentApi.fetchGetEducationHistoryDetail(
      id_student,
      id_student_education
    );
    const data = res.data;

    if (data.status < 300) {
      setData(data.data.student_educational_detail);
      setDataInfo(data.data);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    if (id && id_student) {
      getEducationHistoryDetail(+id_student, +id);
      console.log("fetch");
    }
  }, [id_student, id]);

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: t("STUDENT_MANAGEMENT.TOPIC.MANAGE_STUDENT_LIST"),
            key: "1",
            pathName: routeName.cms.ManageStudents,
          },
          {
            name: t("STUDENT_MANAGEMENT.TOPIC.STUDENT_INFORMATION"),
            key: "2",
            pathName: routeName.cms.ManageStudents + `/detail/${id_student}`,
          },
          {
            name: `ข้อมูลชั้นปีที่ ${dataInfo?.grade_level} ปีการศึกษา ${dataInfo?.year} เทอม ${dataInfo?.term}`,
            key: "3",
            pathName:
              routeName.cms.ManageStudents + `/education-info/term/${id}`,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">
          {`ข้อมูลชั้นปีที่ ${dataInfo?.grade_level} ปีการศึกษา ${dataInfo?.year} เทอม ${dataInfo?.term}`}
        </Typography>
      </section>

      <section className="my-2">
        <StudentInfo
          fulllname={fullname ?? ""}
          nickname={middle_name ?? ""}
          course={course ?? ""}
        />
      </section>

      <section className="my-4">
        <CardSummaryGpa amount={dataInfo?.grade_level} />
      </section>

      {/* main content */}
      <section className="my-4">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>

      <section className="text-center">
        <ButtonBack
          onClick={() => {
            navigate(
              routeName.cms.ManageStudents +
                `/detail/${id_student}?id_student=${id_student}&id_student_register_payment=${id_student_register_payment}&id_student_term_payment=${id_student_term_payment}`
              // routeName.cms.ManageStudents +
              //   `/education-info/term/${id}?id_student=${id_student}&id_student_register_payment=${id_student_register_payment}`
            );
          }}
          buttonName={t("STUDENT_MANAGEMENT.COMMON.BUTTON_BACK")}
          btnProps={{
            width: "150px",
          }}
        />
      </section>
    </div>
  );
};

export default EducationInfoPage;
